export default __webpack_public_path__ + "static/media/coin-binance-black.21063351.svg";